import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GridType } from '@app/pcs/models';
import * as fromRoot from '@app/reducer';
import { select, Store } from '@ngrx/store';
import { hasValue } from '@util';
import { getGridData } from 'ngrx-data-grid';
import * as R from 'ramda';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export type FilterInput<T> = T | T[] | boolean;

export interface SelectGridFilterProps {
  propertyPath: string[];
  gridName: GridType;
  displayProperty: string;
  showRowsWithNoOptions: boolean;
  showRowsWithNoOptionsLabel: string;
}

@Directive()
export abstract class BaseSelectGridFilterDirective<T> implements OnInit {

  @Input() value: FilterInput<T>;
  @Input() props: SelectGridFilterProps;
  @Output() valueChanged = new EventEmitter<FilterInput<T>>();

  options$: Observable<any>;

  protected constructor(protected store?: Store<any>) {
  }

  ngOnInit(): void {
    if (this.store && hasValue(this.props)) {
      this.options$ = this.store.pipe(
        select(fromRoot.getGridState),
        select(getGridData, {gridName: this.props.gridName}),
        map(R.map(R.path(this.props.propertyPath)) as any),
        map(R.flatten),
        map(R.uniq),
        map(R.filter(hasValue))
      );
    }
  }

}
